import { Button } from "@bandit-network/react-ui-kit";
import React, {
  Suspense,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useInView } from "react-intersection-observer";
import QuestCard from "../components/QuestCard";
import { QuestCardSkeleton } from "../components/QuestCardSkeleton";
import { useQuest } from "../hooks/useQuest";
import { changeQueryParams } from "../utils";
// import { QuestWidget } from "./QuestWidget";
import { mainnetChains, testnetChains } from "@bandit-network/react-wallet-kit";
import { useBanditContext } from "../context/BanditQuestContext";

const _testnetChains = () => {
  let chains = [];
  chains.push({
    key: "Solana Devnet",
    value: "solana_devnet",
  });
  chains.push(
    ...testnetChains.map((c) => ({
      key: c.name as string,
      value: c.id.toString() as string,
    })),
  );

  return chains;
};

const _mainnetChains = () => {
  let chains = [];

  chains.push({
    key: "Solana",
    value: "solana",
  });
  chains.push(
    ...mainnetChains.map((c) => ({
      key: c.name as string,
      value: c.id.toString() as string,
    })),
  );

  return chains;
};

const QuestWidget = React.lazy(() =>
  import("./QuestWidget").then((module) => ({
    default: module.QuestWidget,
  })),
);

const PAGE_LIMIT = 12;
const QuestList = ({
  aggregationDisabled = false,
}: {
  aggregationDisabled?: boolean;
}) => {
  const [selectedChain, setSelectedChain] = useState("");
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [collectionId, setCollectionId] = useState<number | null>(null);
  const { ref, inView } = useInView();
  const { address } = useBanditContext();
  const {
    data,
    isFetching,
    isLoading,
    isFetchingNextPage,
    isFetchingPreviousPage,
    fetchNextPage,
    fetchPreviousPage,
    hasNextPage,
    hasPreviousPage,
  } = useQuest({
    aggregationDisabled,
    chain: selectedChain,
    address,
  });
  const { cluster } = useBanditContext();

  const chains = cluster === "devnet" ? _testnetChains() : _mainnetChains();

  useEffect(() => {
    if (inView) {
      fetchNextPage();
    }
  }, [fetchNextPage, inView]);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const collectionId = queryParams.get("collectionId");
    if (!!collectionId) {
      setCollectionId(Number(collectionId));
      setIsOpen(true);
    }
  }, [setCollectionId, setIsOpen]);

  const onClickCollectionCard = useCallback((collectionId: number) => {
    setIsOpen(true);
    setCollectionId(collectionId);
    changeQueryParams(
      window.location.search,
      window.location.pathname,
      String(collectionId),
      (url) => {
        window.history.pushState({}, "", url);
      },
      false,
    );
  }, []);

  const onClose = () => {
    setIsOpen(false);
    changeQueryParams(
      window.location.search,
      window.location.pathname,
      String(collectionId),
      (url) => {
        window.history.pushState({}, "", url);
      },
      true,
    );
  };

  const questList = useMemo(() => {
    const list: any = data;
    return !!list?.pages
      ? list?.pages.reduce((acc, item) => (acc = acc.concat(item)), [])
      : [];
  }, [data]);
  return (
    <div className="">
      {/*<div className="bad-quest_header">*/}
      {/*  <div className="bad-quest_header-left"></div>*/}
      {/*  <div className="bad-quest_header-right">*/}
      {/*    <Select onValueChange={(value) => setSelectedChain(value)}>*/}
      {/*      <SelectTrigger className="bad-quest_header-right_select">*/}
      {/*        <SelectValue placeholder="Select Chain(s)" />*/}
      {/*      </SelectTrigger>*/}
      {/*      <SelectContent>*/}
      {/*        {chains?.map((chain, index) => (*/}
      {/*          <SelectItem key={index} value={chain.value}>*/}
      {/*            {chain.key}*/}
      {/*          </SelectItem>*/}
      {/*        ))}*/}
      {/*      </SelectContent>*/}
      {/*    </Select>*/}
      {/*  </div>*/}
      {/*</div>*/}
      {!isFetching && questList?.length === 0 && (
        <div className="bad-quest_no-quests">
          <p>No Quests Found</p>
        </div>
      )}
      <div className="bad-quest_list">
        {isLoading &&
          [...Array(PAGE_LIMIT)].map((i, index) => (
            <QuestCardSkeleton key={index} />
          ))}
        {questList.map((quest) => {
          return (
            <QuestCard
              key={quest?.collectionId}
              name={quest?.profile?.name}
              source={quest?.consumerName}
              chain={quest?.contract?.chain}
              participants={quest?.participantsCount}
              rewards={"NFT"}
              profilePic={quest?.profile?.profileImage}
              spaceName={quest?.space?.profile?.name}
              spaceProfilePic={quest?.space?.profile?.profileImage}
              onClick={() => onClickCollectionCard(quest?.collectionId)}
              hasUserClaimed={quest?.hasUserClaimed}
            />
          );
        })}
        {(isLoading || isFetching) &&
          [...Array(PAGE_LIMIT)].map((i, index) => (
            <QuestCardSkeleton key={index} />
          ))}
      </div>

      {!isLoading && hasNextPage && (
        <div className="bad-quest_load_more">
          <Button
            ref={ref}
            onClick={() => fetchNextPage()}
            disabled={!hasNextPage || isFetchingNextPage}
          >
            {isFetchingNextPage
              ? "Loading more..."
              : hasNextPage
                ? "Load More"
                : "Nothing more to load"}
          </Button>
        </div>
      )}

      <Suspense fallback={null}>
        <QuestWidget
          isOpen={isOpen}
          dialog={true}
          collectionId={collectionId}
          onClose={onClose}
        />
      </Suspense>
    </div>
  );
};

export { QuestList };
